// Hides each filterable element whose lower-case data-filter-key does not contain the text typed into
// the source input.
// <input data-filter-target="source" data-action="input->filter#filter"> … <tr data-filter-target="filterable" data-filter-key="acme ltd">
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "filterable"]

  filter() {
    const term = this.sourceTarget.value.toLowerCase()
    this.filterableTargets.forEach((element) => {
      element.classList.toggle("filter--notFound", !element.dataset.filterKey.includes(term))
    })
  }
}
